import './ActivityResultStates.scss';

import * as React from 'react';

import { translate } from '~l10n/client';
import { Stack } from '~shared/components/Stack';

import { ActivityResultStateIcon } from './ActivityResultStateIcon';

/**
 * Shown when a report/quiz can't be loaded because its shared library was
 * deleted or the user lost access (server returns `quiz_not_found`).
 */
export const ActivityResultUnavailable = () => {
  return (
    <div className="activity-result-states-container flex flex-col justify-center items-center">
      <ActivityResultStateIcon />
      <div className="px-8 pt-12 max-w-3xl">
        <Stack space="8" align="center">
          <span className="font-display text-md font-500 text-blue-900">
            {translate('This report is no longer available')}
          </span>
          <p className="font-sans text-base leading-8 text-blue-900 text-center">
            {translate(
              'The shared library it belongs to has been deleted or you no longer have access to it. Contact your administrator if you think this is a mistake.'
            )}
          </p>
        </Stack>
      </div>
    </div>
  );
};
